module.exports = __webpack_public_path__ + "static/media/prev-disabled.0550280f.svg";